import { DatePipe } from '@angular/common';
import { SimpleFieldsetComponent } from './simple-fieldset';
import { FilterFieldsetComponent } from "./filter-fieldset";
import * as i0 from "@angular/core";
const Components = [SimpleFieldsetComponent, FilterFieldsetComponent];
export let DynamicFieldsetModule = /*#__PURE__*/(() => {
  class DynamicFieldsetModule {
    static {
      this.ɵfac = function DynamicFieldsetModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFieldsetModule)();
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: DynamicFieldsetModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [DatePipe
        // Restraints,
        ],
        imports: [Components]
      });
    }
  }
  return DynamicFieldsetModule;
})();